import React from "react";
import { Dropdown } from "react-bootstrap";
import DropdownToggle from "components/dropdown-toggle/DropdownToggle";
import { ReactComponent as OutlineChevronDown16 } from "assets/svg/outline-chevron-down-16.svg";
import formatSessionStatus from "components/invoicing/utils/formatSessionStatus";
import styles from "./InvoicingToggle.module.scss";
import getClasses from "utils/getClasses";

const InvoicingToggle = ({
  disabled,
  status,
  onStatusChange,
}: {
  disabled?: boolean;
  status:
    | "complete"
    | "no_show"
    | "cancel"
    | "late_cancel"
    | "cancel_by_patient"; // TODO: need BE fix to remove this type
  onStatusChange: (status: string) => void;
}) => {
  return (
    <DropdownToggle
      title={formatSessionStatus(status)}
      className={getClasses(
        status === "complete"
          ? styles["invoicing-toggle--complete"]
          : styles["invoicing-toggle--cancel"],
        styles["invoicing-toggle"],
      )}
      titleClassName={styles["invoicing-toggle__title"]}
      hideCaret={status !== "complete" || disabled}
      Caret={<OutlineChevronDown16 />}
      disabled={status !== "complete" || disabled}
    >
      <Dropdown.Item onClick={() => onStatusChange("complete")}>
        Complete
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onStatusChange("no_show")}>
        No Show
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onStatusChange("cancel")}>
        Cancel
      </Dropdown.Item>
      <Dropdown.Item onClick={() => onStatusChange("late_cancel")}>
        Late Cancel
      </Dropdown.Item>
    </DropdownToggle>
  );
};

export default InvoicingToggle;
